import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "../Loadable";

const TrainingStart = Loadable(
    lazy(() => import("src/pages/user/training/start"))
);
const TrainingMeeting = Loadable(
    lazy(() => import("src/pages/user/training/meeting"))
);
const TrainingTutorial = Loadable(
    lazy(() => import("src/pages/user/training/tutorial"))
);

const training = {
    path: "training",
    children: [
        { index: true, element: <Navigate to="start" /> },
        { path: "start", element: <TrainingStart /> },
        { path: "meeting", element: <TrainingMeeting /> },
        { path: "tutorial", element: <TrainingTutorial /> },
    ],
};

export default training;